import { Controller } from "@hotwired/stimulus"

// Toggles the mobile marketing nav menu.
export default class extends Controller {
  static targets = ["menu", "toggle"]

  toggle() {
    const open = this.menuTarget.classList.toggle("hidden") === false
    this.menuTarget.classList.toggle("flex", open)
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", String(open))
  }
}
